import SalesOffice from './SalesOffice'
import FullServiceCustomerType from './FullServiceCustomerType'
export class FullServiceCustomer {
    CustomerNumber: string;
    Name: string;
    FullName: string;
    CustomerStreetAddress: string;
    CustomerCity: string;
    CustomerStateProvince: string;
    CustomerPostalCode: string;
    ZQCustomerNumber: string;
    ZQCustomerName: string;
    ZQFullName: string;
    UpdatedPackageCount?: number;
    SalesOffice?: SalesOffice;
    CustomerTypeID?: number;
    FullServiceCustomerType?: FullServiceCustomerType;
    Included?: boolean;
    LinkToSelf?: boolean;
}

export default FullServiceCustomer;